import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://www.thehardwarestore.io";

const PAGES = {
    "/": {
        title: "The Hardware Store — Electrical & Plumbing Supplies India",
        description:
            "India's electrical and plumbing supply partner. Wires, switches, pipes, fittings and pan-India delivery.",
        canonical: `${SITE}/`,
    },
    "/contact": {
        title: "Contact — The Hardware Store",
        description:
            "Call or WhatsApp The Hardware Store for electrical and plumbing quotes. Pan-India delivery.",
        canonical: `${SITE}/contact`,
    },
};

function setMeta(name, content, isProperty = false) {
    const attr = isProperty ? "property" : "name";
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(href) {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export function usePageSeo() {
    const { pathname } = useLocation();

    useEffect(() => {
        const page = PAGES[pathname] || PAGES["/"];
        document.title = page.title;
        setMeta("description", page.description);
        setMeta("og:title", page.title, true);
        setMeta("og:description", page.description, true);
        setMeta("og:url", page.canonical, true);
        setCanonical(page.canonical);
    }, [pathname]);
}
